import { render } from "./FloatingButtonFormBuilder.vue?vue&type=template&id=0d4dcac2&scoped=true"
import script from "./FloatingButtonFormBuilder.vue?vue&type=script&lang=ts"
export * from "./FloatingButtonFormBuilder.vue?vue&type=script&lang=ts"

import "./FloatingButtonFormBuilder.vue?vue&type=style&index=0&id=0d4dcac2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0d4dcac2"

export default script